import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import LoginForm from "../components/PageComponents/LoginForm/LoginForm";

const Home = () => {
  const navigate = useNavigate();
  const cookies = new Cookies(null, { path: "/" });

  useEffect(() => {
    const token = cookies.get("token");
    if (token) {
      navigate("/FirstInput");
    }
  }, []);

  return (
    <div className="home">
      <LoginForm />
    </div>
  );
};

export default Home;
